"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchOpenStatic = exports.useSearchOpen = exports.useDefaultSearchCallback = void 0;
const common_1 = require("@epic-core/common");
const react_1 = require("react");
const navActions_1 = require("../context/navActions");
const navContext_1 = require("../context/navContext");
const useDefaultSearchCallback = (history) => {
    return (0, react_1.useCallback)((query) => {
        history.push((0, common_1.generateRoutePath)(`/bing-search?keyword=${query}`));
    }, [history]);
};
exports.useDefaultSearchCallback = useDefaultSearchCallback;
const useSearchOpen = () => {
    const { state, dispatch } = (0, react_1.useContext)(navContext_1.NavContext);
    const setSearchOpen = (open) => {
        dispatch({ type: navActions_1.ActionTypes.SET_SEARCH_OPEN, value: open });
    };
    return {
        searchOpen: state.searchOpen,
        setSearchOpen,
    };
};
exports.useSearchOpen = useSearchOpen;
const useSearchOpenStatic = () => {
    const { state } = (0, react_1.useContext)(navContext_1.NavContext);
    return state.searchOpen;
};
exports.useSearchOpenStatic = useSearchOpenStatic;
//# sourceMappingURL=search.hooks.js.map